import { appendQueryParams } from './appendQueryParams';
export function appendQueryParam(url, name, value) {
    if (!url || !name) {
        return url;
    }
    var params = {};
    params[name] = value;
    return appendQueryParams(url, params);
}
//# sourceMappingURL=appendQueryParam.js.map